import { OPTIMIZER_URL } from '@/environment'
import { combinePaths, queryParams } from '@attensi/utils'
import {
  OPTIMIZER_APP_CONFIG,
  OPTIMIZER_SOURCE_CONFIG,
} from './optimizerConfig'

export const getSrcSet = (src: string | undefined) => {
  if (!src) return

  return OPTIMIZER_APP_CONFIG.widths
    .map((width) => `${optimizeImage(src, width)} ${width}w`)
    .join(', ')
}

const optimizeImage = (src: string, width: number) => {
  const optimizedUrl = replaceSourceOrigin(src)
  return queryParams(optimizedUrl, { w: width })
}

const replaceSourceOrigin = (src: string) => {
  for (const source of OPTIMIZER_SOURCE_CONFIG) {
    if (src.startsWith(source.baseUrl)) {
      const withoutBase = src.replace(source.baseUrl, '')
      return combinePaths(
        OPTIMIZER_URL,
        source.name,
        OPTIMIZER_APP_CONFIG.name,
        withoutBase
      )
    }
  }
  return src
}
